import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  width: 100%;
  padding: 1em;

  .header-acessos {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5em;

    h3 {
      font-size: 1.2em;
      font-weight: 600;
      color: ${Colors.text_Color_1};
    }

    .btn-adicionar {
      display: flex;
      align-items: center;
      gap: 0.4em;
      padding: 0.5em 1em;
      background: ${Colors.Color4};
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 0.85em;
      font-weight: 500;
      transition: all 0.2s;

      &:hover {
        background: ${Colors.Color4}dd;
        // transform: translateY(-1px);
      }

      .material-icons {
        font-size: 1.1em;
      }
    }
  }

  .lista-acessos {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1.2em;
    max-height: 60vh;
    overflow-y: auto;
    padding-right: 0.5em;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: ${Colors.Border_Color_1};
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${Colors.Color4};
      border-radius: 3px;
    }
  }

  .empty-state {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3em;
    color: ${Colors.Color7};
    text-align: center;

    .material-icons {
      font-size: 4em;
      opacity: 0.3;
      margin-bottom: 0.5em;
    }

    p {
      font-size: 1.1em;
      margin-bottom: 0.3em;
    }

    small {
      font-size: 0.85em;
      opacity: 0.7;
    }
  }
`;

export const AcessoCard = styled.div`
  background: ${Colors.Color8};
  border: 1px solid ${Colors.Border_Color_1};
  border-radius: 8px;
  padding: 1.2em;
  transition: all 0.2s;
  opacity: ${props => (props.ativo ? 1 : 0.6)};
  min-height: 180px;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-color: ${Colors.Color4};
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1em;
    padding-bottom: 0.8em;
    border-bottom: 1px solid ${Colors.Border_Color_1};
    flex-shrink: 0;

    .login-info {
      display: flex;
      align-items: flex-start;
      gap: 0.8em;
      flex: 1;
      min-width: 0;

      .material-icons {
        font-size: 2em;
        color: ${Colors.Color4};
        flex-shrink: 0;
      }

      > div {
        min-width: 0;
        flex: 1;
      }

      .login-principal {
        font-size: 0.95em;
        font-weight: 600;
        color: ${Colors.text_Color_1};
        margin-bottom: 0.3em;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .login-api {
        font-size: 0.8em;
        color: ${Colors.Color7};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .badge-status {
      padding: 0.3em 0.8em;
      border-radius: 12px;
      font-size: 0.75em;
      font-weight: 500;
      white-space: nowrap;
      flex-shrink: 0;
      margin-left: 0.5em;

      &[data-ativo='true'] {
        background: ${Colors.Color4}22;
        color: ${Colors.Color4};
      }

      &[data-ativo='false'] {
        background: ${Colors.Color7}22;
        color: ${Colors.Color7};
      }
    }
  }

  .card-body {
    margin-bottom: auto;
    padding-bottom: 1em;
    flex-shrink: 0;

    .portal-info {
      display: flex;
      align-items: center;
      gap: 0.5em;
      color: ${Colors.text_Color_1};
      min-width: 0;

      .material-icons {
        font-size: 1em;
        color: ${Colors.Color7};
        flex-shrink: 0;
      }

      p {
        font-size: 0.75em;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        min-width: 0;
      }
    }
  }

  .card-footer {
    display: flex;
    gap: 0.5em;
    flex-shrink: 0;

    button {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.3em;
      padding: 0.4em 0.5em;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 0.75em;
      transition: all 0.2s;
      font-weight: 500;

      .material-icons {
        font-size: 1em;
      }
    }

    .btn-editar {
      background: ${Colors.Color4}22;
      color: ${Colors.Color4};

      &:hover {
        background: ${Colors.Color4};
        color: white;
      }
    }

    .btn-excluir {
      background: ${Colors.ft_color_10}22;
      color: ${Colors.ft_color_10};

      &:hover {
        background: ${Colors.ft_color_10};
        color: white;
      }
    }
  }
`;

export const ModalContent = styled.div`
  background: ${Colors.Color13};
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  border: 1px solid ${Colors.Border_Color_1};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem;
  border-bottom: 1px solid ${Colors.Border_Color_1};
`;

export const ModalTitle = styled.h2`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${Colors.text_Color_1};
  margin: 0;
`;

export const ModalCloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: ${Colors.Color7};
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 4px;

  &:hover {
    color: ${Colors.text_Color_1};
    background: ${Colors.Border_Color_1};
  }
`;

export const ModalBody = styled.div`
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;

  .row {
    margin-bottom: 0.8em;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem;
  border-top: 1px solid ${Colors.Border_Color_1};
  background: ${Colors.Color8};
  width: 100%;
`;

export const ModalButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: ${props => (props.secondary ? 'transparent' : Colors.bgButton1)};
  border: 1px solid ${props => (props.secondary ? Colors.Border_Color_1 : 'transparent')};
  color: ${props => (props.secondary ? Colors.Color9 : Colors.ftColor4)};
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  width: 100%;

  &:hover {
    opacity: 0.9;
    // transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;
